module.exports = __webpack_public_path__ + "media/images/reports/financial_statements-0c2abb81578c95fc5965eb4ba0bd9e72.svg";